module.exports = __webpack_public_path__ + "static/media/share_5.7775f5fc.png";